function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsEmptyWindow } from '@deephaven/icons';
import { Content, Heading, Icon, IllustratedMessage } from "./spectrum/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DEFAULT_DELAY_MS = 500;
export function TableViewEmptyState(_ref) {
  var heading = _ref.heading,
    content = _ref.content,
    _ref$delayMs = _ref.delayMs,
    delayMs = _ref$delayMs === void 0 ? DEFAULT_DELAY_MS : _ref$delayMs;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];

  // Spectrum `TableView` will render the result of `renderEmptyState` prop
  // immediately, and it will be hidden once data loads. In cases where the data
  // load is quick, there is a jarring flicker, and the empty data message is
  // not helpful. This delay will avoid showing the message if data loads within
  // the `delayMs`.
  useEffect(() => {
    window.setTimeout(() => {
      setShow(true);
    }, delayMs);
  }, [delayMs]);
  return show ? /*#__PURE__*/_jsxs(IllustratedMessage, {
    children: [/*#__PURE__*/_jsx(Icon, {
      size: "XXL",
      children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: vsEmptyWindow
      })
    }), /*#__PURE__*/_jsx(Heading, {
      children: heading
    }), content == null ? null : /*#__PURE__*/_jsx(Content, {
      children: content
    })]
  }) : null;
}
export default TableViewEmptyState;
//# sourceMappingURL=TableViewEmptyState.js.map